export default "__VITE_ASSET__C_5S8zDx__"